<template>
  <a-upload
    name="avatar"
    list-type="picture-card"
    class="avatar-uploader"
    :show-upload-list="false"
    :action="null"
    :before-upload="beforeUpload"
    :custom-request="customRequestHandler"
    @change="handleChange"
    :style="{ width: width + 'px', height: height + 'px' }"
  >
    <div
      v-if="imageUrl && !loadingFile"
      class="avatar-wrapper"
      :style="{
        width: width + 'px',
        height: height + 'px',
        minWidth: width + 'px',
        minHeight: height + 'px',
        borderRadius: '50%'
      }"
    >
      <img
        :src="imageUrl"
        alt="logo"
        :style="{
          width: width + 'px',
          height: height + 'px',
          minWidth: width + 'px',
          minHeight: height + 'px',
          borderRadius: '50%'
        }"
      />
      <div class="overlay">
        <a-icon type="edit" theme="twoTone" twoToneColor="#fff" />
      </div>
    </div>

    <div
      v-else
      class="flex flex-column align-items-center justify-content-center"
      :style="{ width: width + 'px', height: height + 'px' }"
    >
      <a-icon :type="loadingFile ? 'loading' : 'plus'" />
      <div class="ant-upload-text">Upload</div>
    </div>
  </a-upload>
</template>

<script>
import { Icon, Upload } from 'ant-design-vue'

function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

export default {
  components: {
    'a-upload': Upload,
    'a-icon': Icon
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 128
    },
    height: {
      type: Number,
      default: 128
    },
    path: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      loadingFile: false,

      imageUrl: ''
    }
  },
  watch: {
    url: {
      handler(newVal) {
        this.imageUrl = newVal
      },
      immediate: true
    }
  },
  methods: {
    handleChange(info) {
      getBase64(info.file.originFileObj, imageUrl => {
        this.imageUrl = imageUrl
      })
    },
    customRequestHandler(options) {
      options.onSuccess('success', options.file)
    },
    beforeUpload(file, fileList) {
      const allowedExtensions = ['png', 'jpg', 'jpeg', 'svg']

      const fileExtension = file.name.split('.').pop().toLowerCase()

      if (!allowedExtensions.includes(fileExtension)) {
        this.showNotification('error', 'Error', 'This file type is not allowed.')
        return false
      }

      this.fileList = [file]

      if (fileList.length > 0 && fileList[fileList.length - 1] === file) {
        this.customRequest(fileList)
      }

      return true
    },

    async customRequest(uploadedFiles) {
      this.loadingFile = true
      try {
        const data = await this.$store.dispatch('uploadFiles', {
          files: uploadedFiles,
          path: this.path
        })

        if (!data || !data.ids || !data.ids.length) {
          throw new Error('Error occurred while uploading files.')
        }

        this.$emit('upload', data.ids[0])
      } catch (error) {
      } finally {
        this.loadingFile = false
      }
    }
  }
}
</script>

<style scoped>
::v-deep .ant-upload-picture-card-wrapper {
  width: fit-content;
  align-self: center;
}

.avatar-wrapper {
  width: fit-content;
  height: fit-content;
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.avatar-wrapper .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.avatar-wrapper:hover .overlay {
  opacity: 1;
}

.avatar-uploader > .ant-upload {
  width: fit-content;
  height: fit-content;
}

.ant-upload-select-picture-card i {
  font-size: 18px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

::v-deep .ant-upload.ant-upload-select-picture-card > .ant-upload {
  padding: 0 !important;
}

::v-deep .ant-upload.ant-upload-select-picture-card {
  margin: 0 !important;
  border-radius: 50%;
  width: fit-content;
  height: fit-content;
}
</style>
